import React from 'react';
import styled from 'styled-components';

import { FullHeightContainer } from '../../Containers';
import { Header } from '../../Header';

import { createMarkup } from '../../../utils';
import { breakpoints } from '../../../constants';

const IntroParagraph = styled.p`
    max-width: 580px;
    text-align: center;
    margin-bottom: 20px;
    line-height: 1.2;

    @media (${breakpoints.smallMin}) {
        line-height: 1.6;
    }
`;

interface IProps {
    style?: React.CSSProperties;
}

export const Explanation: React.FC<IProps> = ({ style }) => {
    const introParagraphText =
        'In onze online oogcheck stellen we je een aantal vragen over kijkgedrag en lifestyle. De online oogcheck is geen echte oogmeting en niet te vergelijken met een deskundige oogmeting door een gediplomeerde opticien bij Pearle. Na afloop van de online oogcheck weet je wel wat je te wachten staat bij ons Goed Zicht Gesprek en de échte oogmeting, waar op gelet wordt door een opticien en hoe je beter voor je ogen kunt zorgen. Je kunt ervoor kiezen om na het doen van de online oogcheck een afspraak te maken in één van onze winkels voor een Goed Zicht Gesprek, inclusief gratis oogmeting t.w.v. 30.-.';

    return (
        <FullHeightContainer isInstruction style={{ ...style }}>
            <Header>
                <strong>De online oogcheck</strong>
            </Header>
            <IntroParagraph
                dangerouslySetInnerHTML={createMarkup(introParagraphText)}
            />
        </FullHeightContainer>
    );
};
